"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const tinymce_react_1 = require("@tinymce/tinymce-react");
require("tinymce/tinymce");
require("tinymce/icons/default");
require("tinymce/themes/silver");
require("tinymce/models/dom");
require("tinymce/plugins/advlist");
require("tinymce/plugins/autolink");
require("tinymce/plugins/lists");
require("tinymce/plugins/link");
require("tinymce/plugins/charmap");
require("tinymce/plugins/preview");
require("tinymce/plugins/anchor");
require("tinymce/plugins/searchreplace");
require("tinymce/plugins/visualblocks");
require("tinymce/plugins/code");
require("tinymce/plugins/insertdatetime");
require("tinymce/plugins/table");
require("tinymce/plugins/wordcount");
require("tinymce/plugins/image");
require("tinymce/plugins/media");
const editorStyle_1 = __importDefault(require("../../hooks/editorStyle"));
const CustomImageEditor = ({ editorValue = "", setEditorValue, initialWidth = 300, initialHeight = 150, initialX = 0, initialY = 0, image, width, height, borderWidth, borderStyle, borderColor, borderRadius, rotate, vspace, hspace, isResizable = true, isDraggable = true, }) => {
    const wrapperId = "my-editor-wrapper";
    (0, editorStyle_1.default)(wrapperId);
    const applyImageProps = (img) => {
        if (!img)
            return;
        if (width)
            img.style.width = typeof width === "number" ? `${width}px` : width;
        if (height)
            img.style.height = typeof height === "number" ? `${height}px` : height;
        if (borderWidth)
            img.style.borderWidth = borderWidth;
        if (borderStyle)
            img.style.borderStyle = borderStyle;
        if (borderColor)
            img.style.borderColor = borderColor;
        if (borderRadius)
            img.style.borderRadius = borderRadius;
        if (rotate !== undefined)
            img.style.transform = `rotate(${rotate}deg)`;
        if (vspace)
            img.setAttribute("vspace", vspace.toString());
        if (hspace)
            img.setAttribute("hspace", hspace.toString());
    };
    (0, react_1.useEffect)(() => {
        if (image && setEditorValue) {
            const imgHtml = `<img src="${image}" 
        style="
          ${width ? `width:${typeof width === "number" ? width + "px" : width};` : ""}
          ${height ? `height:${typeof height === "number" ? height + "px" : height};` : ""}
          ${borderWidth ? `border-width:${borderWidth};` : ""}
          ${borderStyle ? `border-style:${borderStyle};` : ""}
          ${borderColor ? `border-color:${borderColor};` : ""}
          ${borderRadius ? `border-radius:${borderRadius};` : ""}
          ${rotate !== undefined ? `transform:rotate(${rotate}deg);` : ""}
        "
        ${vspace ? `vspace="${vspace}"` : ""}
        ${hspace ? `hspace="${hspace}"` : ""}
      />`;
            setEditorValue(imgHtml);
        }
    }, [image, width, height, borderWidth, borderStyle, borderColor, borderRadius, rotate, vspace, hspace]);
    return ((0, jsx_runtime_1.jsx)("div", { id: wrapperId, style: { height: "100%" }, children: (0, jsx_runtime_1.jsx)(tinymce_react_1.Editor, { licenseKey: "gpl", value: editorValue, onEditorChange: (content) => setEditorValue && setEditorValue(content), init: {
                inline: true,
                base_url: "/tinymce",
                suffix: ".min",
                height: "100%",
                width: "100%",
                menubar: false,
                statusbar: false,
                branding: false,
                plugins: ["image", "media"],
                toolbar: "image media | code",
                image_toolbar: "imageoptions",
                image_advtab: true,
                automatic_uploads: true,
                file_picker_types: "image",
                file_picker_callback: (callback) => {
                    const input = document.createElement("input");
                    input.setAttribute("type", "file");
                    input.setAttribute("accept", "image/*");
                    input.onchange = function (event) {
                        var _a, _b;
                        const file = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];
                        if (!file)
                            return;
                        const reader = new FileReader();
                        reader.onload = function () {
                            const base64 = reader.result;
                            callback(base64, { title: file.name });
                        };
                        reader.readAsDataURL(file);
                    };
                    input.click();
                },
                setup: (editor) => {
                    editor.on("Init", () => {
                        const imgs = editor.getBody().querySelectorAll("img");
                        imgs.forEach((img) => applyImageProps(img));
                    });
                    editor.ui.registry.addContextToolbar("customImageToolbar", {
                        predicate: (node) => node.nodeName.toLowerCase() === "img",
                        items: "imageoptions imageBorderSettings imageRotate imageCrop",
                        position: "node",
                        scope: "node",
                    });
                    editor.ui.registry.addButton("imageBorderSettings", {
                        icon: "border-width",
                        tooltip: "Border Settings",
                        onAction: () => {
                            const selectedNode = editor.selection.getNode();
                            let currentBorder = "";
                            let currentRadius = "";
                            if (selectedNode && selectedNode.nodeName === "IMG") {
                                currentBorder = selectedNode.style.borderColor || "";
                                currentRadius = selectedNode.style.borderRadius || "";
                            }
                            editor.windowManager.open({
                                title: "Image Border Settings",
                                body: {
                                    type: "panel",
                                    items: [
                                        {
                                            type: "colorinput",
                                            name: "borderColor",
                                            label: "Border Color",
                                        },
                                        {
                                            type: "input",
                                            name: "borderRadius",
                                            label: "Border Radius (px)",
                                        },
                                    ],
                                },
                                initialData: {
                                    borderColor: currentBorder,
                                    borderRadius: currentRadius.replace("px", ""),
                                },
                                buttons: [
                                    { type: "cancel", text: "Cancel" },
                                    { type: "submit", text: "Apply", primary: true },
                                ],
                                onSubmit: (api) => {
                                    const data = api.getData();
                                    if (selectedNode && selectedNode.nodeName === "IMG") {
                                        const img = selectedNode;
                                        if (data.borderColor) {
                                            img.style.borderColor = data.borderColor;
                                        }
                                        if (data.borderRadius) {
                                            img.style.borderRadius = `${data.borderRadius}px`;
                                        }
                                    }
                                    api.close();
                                },
                            });
                        },
                    });
                    editor.ui.registry.addButton("imageRotate", {
                        icon: "rotate-left",
                        tooltip: "Rotate Image",
                        onAction: () => {
                            const selectedNode = editor.selection.getNode();
                            if (selectedNode && selectedNode.nodeName === "IMG") {
                                const img = selectedNode;
                                const transformValue = img.style.transform || "";
                                const currentRotate = transformValue.match(/rotate\(([-0-9]+)deg?\)/);
                                let currentDeg = currentRotate ? parseInt(currentRotate[1]) : 0;
                                editor.windowManager.open({
                                    title: "Rotate Image",
                                    body: {
                                        type: "panel",
                                        items: [
                                            {
                                                type: "input",
                                                name: "rotate",
                                                label: "Rotate (degrees)",
                                            },
                                        ],
                                    },
                                    initialData: { rotate: currentDeg.toString() },
                                    buttons: [
                                        { type: "cancel", text: "Cancel" },
                                        { type: "submit", text: "Apply", primary: true },
                                    ],
                                    onSubmit: (api) => {
                                        const data = api.getData();
                                        const degrees = parseInt(data.rotate) || 0;
                                        img.style.transform = `rotate(${degrees}deg)`;
                                        api.close();
                                    },
                                });
                            }
                        },
                    });
                },
            } }) }));
};
exports.default = CustomImageEditor;
